import { InjectionToken } from '@angular/core';

export interface TextbookActionsConfig {
  dummy: '';
}

export const TxtbActionsConfig = new InjectionToken<TextbookActionsConfig>('TxtbConfig');

export const TextbookActionsDefaultConfig: TextbookActionsConfig = {
  dummy: '',
};
